import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grocerycartdata from "./importcartpages/Grocerycartdata";
import axios from "axios";
import Groceryandbeveragesadvertise from "../pages/Groceryandbeveragesadvertise";
import allCartsImage from "../../../../images/products/meals.jpg"; // adjust path

const Grocerycart = () => {
    const [quantities, setQuantities] = useState({});
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [refresh, setRefresh] = useState(false);

    const isMobile = window.innerWidth <= 768;

    // ✅ Fetch Cart Data
    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            console.log("📦 Fetching cart for vendor:", vendorId);

            try {
                const response = await axios.get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/cart/${vendorId}`,
                    {
                        headers: {
                            accept: "*/*",
                            ...(token ? { Authorization: `Bearer ${token}` } : {}),
                        },
                    }
                );

                console.log("✅ Cart API response:", response.data);

                const cartData =
                    Array.isArray(response.data) && response.data.length > 0
                        ? response.data[0]
                        : response.data || {};

                const items = cartData.items || [];

                if (items.length === 0) {
                    console.warn("⚠️ No cart items found.");
                }

                // ✅ Normalize structure
                const normalizedItems = items.map((i) => ({
                    cartItemId: i.cartItemId || i.id || i.itemId,
                    dishId: i.dishId || i.itemId,
                    itemName: i.itemName || i.name || i.item?.name || "Unnamed Item",
                    itemPrice: i.itemPrice || i.price || i.item?.price || 0,
                    quantity: i.quantity ?? 1,
                    total: i.total ?? (i.quantity ?? 1) * (i.itemPrice || i.item?.price || 0),
                    itemType: i.itemType || "Other",
                }));

                // ✅ Save to state
                setCartData(normalizedItems);
                setFilteredItems(normalizedItems);

                // ✅ Category list
                const categories = [
                    ...new Set(normalizedItems.map((item) => item.itemType || "Other")),
                ];
                setAllCategories(["Allcarts", ...categories]);

                // ✅ Quantity handling
                const savedQuantities =
                    JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};

                normalizedItems.forEach((item) => {
                    updatedQuantities[item.dishId] =
                        savedQuantities[item.dishId] ?? item.quantity ?? 1;
                });

                setQuantities(updatedQuantities);
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));
            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                alert("Failed to load cart data: " + error.message);
            }
        };

        fetchCartData();
    }, []);

    // ✅ Category filtering
    const handleCategoryClick = (category) => {
        setActiveCategory(category);
        if (category === "Allcarts") {
            setFilteredItems(cartData);
        } else {
            const filtered = cartData.filter((item) => item.itemType === category);
            setFilteredItems(filtered);
        }
        setTimeout(() => setRefresh((prev) => !prev), 0);
    };

    // ✅ Reapply filter on refresh
    useEffect(() => {
        let selectedItems =
            activeCategory === "Allcarts"
                ? cartData
                : cartData.filter((item) => item.itemType === activeCategory);
        setFilteredItems([...selectedItems]);
    }, [activeCategory, cartData, refresh]);

    return (
        <div className="container-fluid">
            <div className="row" style={{ marginTop: "50px" }}>
                {/* ✅ Sidebar */}
                <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                    <div
                        className="category-sidebar d-none d-sm-block mobile-scrolling-cart"
                        style={{
                            maxHeight: "600px",
                            position: "sticky",
                            top: "0px",
                            marginTop: "5px",
                            zIndex: 1000,
                            width: "180px",
                        }}
                    >
                        <div
                            className="category-container"
                            style={{
                                overflowY: "auto",
                                height: "556px",
                                marginTop: "68px",
                            }}
                        >
                            {allCategories.map((category, index) => {
                                const categoryImage =
                                    category === "Allcarts"
                                        ? allCartsImage
                                        : cartData.find((item) => item.itemType === category)?.dishImage ||
                                        allCartsImage;

                                return (
                                    <div
                                        key={index}
                                        className="category-card"
                                        onClick={() => handleCategoryClick(category)}
                                        style={{
                                            backgroundColor:
                                                activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                            margin: "8px 0",
                                            padding: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            cursor: "pointer",
                                            justifyContent: "center",
                                            borderRadius: "15px",
                                            transition: "0.3s ease-in-out",
                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                            height: "165px",
                                        }}
                                    >
                                        <img
                                            src={categoryImage}
                                            alt={category}
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                        <div className="category-card-body d-flex justify-content-center p-0">
                                            <button
                                                style={{
                                                    backgroundColor:
                                                        activeCategory === category ? "#ddd" : "#fff",
                                                    margin: "5px",
                                                    padding: "8px",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    transition: "0.3s ease-in-out",
                                                }}
                                            >
                                                {category}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* ✅ Mobile Dropdown */}
                <div className="d-block d-sm-none" style={{ marginTop: "65px", width: "100%" }}>
                    <select
                        className="form-control"
                        onChange={(e) => handleCategoryClick(e.target.value)}
                        value={activeCategory}
                        style={{
                            padding: "8px",
                            borderRadius: "10px",
                            border: "1px solid #ccc",
                            width: "100%",
                            background: "#b15dc6",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "20px",
                        }}
                    >
                        {allCategories.map((category, index) => (
                            <option key={index} value={category}>
                                {category}
                            </option>
                        ))}
                    </select>
                </div>

                {/* ✅ Main Content */}
                <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: isMobile ? "50px" : "80px",
                            left: isMobile ? "5px" : "275px",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link to="/Newmainlandingpage" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Home
                        </Link>
                        <span> &gt; </span>
                        <Link to="/foodladingpage" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Fresh & Groceries
                        </Link>
                        <span> &gt; </span>
                        <Link to="/grocerymenudatas" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Menu_Management
                        </Link>
                        <span> &gt; </span>
                        <Link to="/grocerycart" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Cart
                        </Link>
                    </p>

                    <div
                        className="cartsizes"
                        style={{
                            marginTop: "100px",
                            padding: "20px",
                            borderRadius: "8px",
                        }}
                    >
                        <Grocerycartdata key={activeCategory} filteredDataProp={filteredItems} />
                    </div>
                </div>

                {/* ✅ Advertisement Section */}
                <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                    <Groceryandbeveragesadvertise />
                </div>
            </div>
        </div>
    );
};

export default Grocerycart;
